__turbopack_context__.v({
  "Img": "QfVYZa_Img",
  "ProviderLink": "QfVYZa_ProviderLink",
});
